import { useEffect, useState } from "react";
import { useGlobalStore } from "@/store/GlobalStore";
import { ActivityTypeCode } from "project-config/constants/activity-code";
import request from "project-config/services/request/request";
import { BindActivityInfo } from "@/components/top-up/types";

export function useLotteryHeader() {
  const { isSubAccount } = useGlobalStore();
  const [showLotteryHeader, setShowLotteryHeader] = useState(false);

  const initActivityInfo = async () => {
    if (isSubAccount) return;
    const { data } = await request.post<BindActivityInfo[]>(
      "/api/rendering/user/activity/template/getSupportActivity"
    );

    const { data: claimData } = await request.post<{ activityId: number }>(
      "/api/rendering/pay/activity/template/claimPrizeInfo"
    );
    const lotteryDataSource = data
      ? data.find(
          (item) => item.activityType === ActivityTypeCode.LuckyDrawGift
        )
      : data;
    setShowLotteryHeader(data ? !!lotteryDataSource : !!data);
    // 是否存在抽奖活动
    if (claimData && claimData.activityId) {
      setShowLotteryHeader(true);
      return;
    }
  };

  useEffect(() => {
    initActivityInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubAccount]);

  return {
    showLotteryHeader,
  };
}
